import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { SubscriptionService } from '../../subscription.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../../loader.service';
import { getDateFromEpoch } from '../../../utils/utils';
import { AuthService } from '../../../auth.service';
import { ConfirmDialogService } from '../../../shared/confirm-dialog/confirm-dialog.service';
import { AlertDialogService } from '../../../shared/alert-dialog/alert-dialog.service';
import { subscriptionOperationFailureAlert, subscriptionUpdateSuccessAlert } from '../../subscription.create-alert';
import { SharedService } from '../../../shared/shared.service';
import { skipServiceHierarchyForMode } from '../../subscription.applicable-types';
import { AuthzAccessHintService } from '../../../shared/authz-access-hint/authz-access-hint.service';
import { AUTHZ_FEATURES } from '../../../constants/permissions';
import { permissionsForFeature } from '../../../utils/permission.utils';
var ViewSubscriptionRuleComponent = /** @class */ (function () {
    function ViewSubscriptionRuleComponent(subscriptionService, route, loaderService, router, accessRights, dialogService, alertDialogService, sharedService, authzAccessHintService) {
        this.subscriptionService = subscriptionService;
        this.route = route;
        this.loaderService = loaderService;
        this.router = router;
        this.accessRights = accessRights;
        this.dialogService = dialogService;
        this.alertDialogService = alertDialogService;
        this.sharedService = sharedService;
        this.authzAccessHintService = authzAccessHintService;
        this.ruleData = {};
        this.canDeactivate = false;
        this.authzAccessHint = null;
        this.categoryName = '';
        this.modeName = '';
        this.isEntireMode = false;
        this.categoryServices = [];
    }
    ViewSubscriptionRuleComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var editPermission, _a, ruleId, res, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        editPermission = (permissionsForFeature(AUTHZ_FEATURES.SUBSCRIPTION, this.accessRights.getAuthzPanels()) || {}).edit;
                        this.canDeactivate = this.accessRights.isAuthorizedFor(editPermission, AUTHZ_FEATURES.SUBSCRIPTION);
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('subscription')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        this.loaderService.openLoading();
                        ruleId = this.route.snapshot.paramMap.get('id');
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, 6, 7]);
                        return [4 /*yield*/, this.subscriptionService.getSubscriptionRule(ruleId).toPromise()];
                    case 3:
                        res = _b.sent();
                        this.ruleData = res;
                        this.ruleData.startDate = getDateFromEpoch(this.ruleData.startTime);
                        this.ruleData.endDate = getDateFromEpoch(this.ruleData.endTime);
                        this.ruleData.cityNames = this.uniqueValues(this.ruleData.cityNames);
                        return [4 /*yield*/, this.resolveGrainApplicability()];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        err_1 = _b.sent();
                        console.log(err_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.loaderService.closeLoading();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ViewSubscriptionRuleComponent.prototype, "showDeactivate", {
        get: function () {
            return this.canDeactivate && this.ruleData && this.ruleData.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSubscriptionRuleComponent.prototype, "cashbackValidity", {
        get: function () {
            var list = this.ruleData && this.ruleData.cashbackValidity;
            return (list && list[0]) || null;
        },
        enumerable: true,
        configurable: true
    });
    ViewSubscriptionRuleComponent.prototype.uniqueValues = function (values) {
        if (!Array.isArray(values)) {
            return values;
        }
        var seen = {};
        return values.filter(function (value) {
            var key = String(value);
            if (seen[key]) {
                return false;
            }
            seen[key] = true;
            return true;
        });
    };
    ViewSubscriptionRuleComponent.prototype.displayOrNA = function (value) {
        return value === null || value === undefined || value === '' ? 'NA' : value;
    };
    Object.defineProperty(ViewSubscriptionRuleComponent.prototype, "showGrainApplicability", {
        get: function () {
            return this.isEntireMode || !!this.categoryApplicability;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSubscriptionRuleComponent.prototype, "applicabilityText", {
        get: function () {
            if (this.isEntireMode) {
                return 'Applicable for entire ' + (this.modeName || 'mode') + ' mode';
            }
            if (this.categoryApplicability) {
                var exclude = this.excludedServiceNames;
                return 'Applicable for entire ' + (this.categoryName || 'category') + ' category'
                    + (exclude ? ', excluding: ' + exclude : '');
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSubscriptionRuleComponent.prototype, "categoryApplicability", {
        get: function () {
            var categories = this.ruleData
                && this.ruleData.categoryLevelApplicability
                && this.ruleData.categoryLevelApplicability.categories;
            return (categories && categories[0]) || null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewSubscriptionRuleComponent.prototype, "excludedServiceNames", {
        get: function () {
            var _this = this;
            var excluded = (this.categoryApplicability && this.categoryApplicability.excludedServices) || [];
            if (!excluded.length) {
                return '';
            }
            var services = this.ruleData.services || [];
            var names = this.ruleData.serviceNames || [];
            return excluded.map(function (id) {
                var fromCategory = _this.categoryServices.find(function (service) { return String(service.id) === String(id); });
                if (fromCategory && fromCategory.name) {
                    return fromCategory.name;
                }
                var index = services.findIndex(function (serviceId) { return String(serviceId) === String(id); });
                return index !== -1 && names[index] ? names[index] : id;
            }).join(', ');
        },
        enumerable: true,
        configurable: true
    });
    ViewSubscriptionRuleComponent.prototype.resolveGrainApplicability = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cityId, modeId, skipRes, toggle, err_2, modesRes, mode, err_3, category, res, match, err_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cityId = (this.ruleData.cities && this.ruleData.cities[0]) || this.ruleData.city;
                        modeId = this.ruleData.mode;
                        this.modeName = modeId || '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.subscriptionService.getSkipServiceHierarchyToggle().toPromise()];
                    case 2:
                        skipRes = _a.sent();
                        toggle = (skipRes && skipRes.data) || skipRes || {};
                        this.isEntireMode = skipServiceHierarchyForMode(toggle, modeId, cityId);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        this.isEntireMode = false;
                        return [3 /*break*/, 4];
                    case 4:
                        if (!cityId || !modeId) {
                            if (this.categoryApplicability) {
                                this.categoryName = this.categoryApplicability.name || this.categoryApplicability.id;
                            }
                            return [2 /*return*/];
                        }
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.sharedService.fetchModes(cityId).toPromise()];
                    case 6:
                        modesRes = _a.sent();
                        mode = ((modesRes && modesRes.data && modesRes.data.modes) || [])
                            .find(function (item) { return String(item.id) === String(modeId); });
                        if (mode && mode.name) {
                            this.modeName = mode.name;
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        err_3 = _a.sent();
                        console.log(err_3);
                        return [3 /*break*/, 8];
                    case 8:
                        if (this.isEntireMode) {
                            return [2 /*return*/];
                        }
                        category = this.categoryApplicability;
                        if (!category) {
                            return [2 /*return*/];
                        }
                        this.categoryName = category.name || category.id;
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.sharedService.fetchSubscriptionServiceOptions(cityId, modeId).toPromise()];
                    case 10:
                        res = _a.sent();
                        this.categoryServices = (res && res.data && res.data.services) || [];
                        match = ((res && res.data && res.data.categories) || [])
                            .find(function (item) { return String(item.id) === String(category.id); });
                        if (match && match.name) {
                            this.categoryName = match.name;
                        }
                        return [3 /*break*/, 12];
                    case 11:
                        err_4 = _a.sent();
                        console.log(err_4);
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    ViewSubscriptionRuleComponent.prototype.showAlertBox = function (options) {
        this.alertDialogService.open(options);
    };
    ViewSubscriptionRuleComponent.prototype.deactivateSubs = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    title: 'Are you sure you want to deactivate the subscription?',
                    message: "You are about to deactivate subscription " + this.ruleData.ruleName,
                    cancelText: 'Cancel',
                    confirmText: 'Yes, Proceed'
                };
                this.dialogService.open(options);
                this.dialogService.confirmed().subscribe(function (confirmed) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var resp, error_1;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!confirmed) {
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.subscriptionService.updateRule(this.ruleData.id || this.route.snapshot.paramMap.get('id'), { active: false }).toPromise()];
                            case 2:
                                resp = _a.sent();
                                this.ruleData.active = false;
                                this.showAlertBox(subscriptionUpdateSuccessAlert(resp));
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                this.showAlertBox(subscriptionOperationFailureAlert(error_1));
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    return ViewSubscriptionRuleComponent;
}());
export { ViewSubscriptionRuleComponent };
